import set from 'ramda/src/set'
import lensPath from 'ramda/src/lensPath'

import { SET_SHARE_URL } from 'root/src/client/logic/static/actionIds'

export default {
	[SET_SHARE_URL]: (state, payload) => set(lensPath(['staticData', 'shareUrl']), payload, state),
}
